"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draftClaimSchema = void 0;
var borrower_charge_1 = require("./borrower-charge");
var borrower_1 = require("./borrower");
var constants_1 = require("../constants");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var document_access_control_entry_schema_1 = require("../common/document-access-control-entry-schema");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var listing_1 = require("./listing");
var net_operating_income_rental_income_1 = require("./net-operating-income-rental-income");
var partial_payment_1 = require("./partial-payment");
var property_1 = require("./property");
var common_1 = require("../common");
exports.draftClaimSchema = {
    type: 'object',
    required: ['cmhcLoanAccountNumber', 'claimTypeIndicator'],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        approvedLenderReferenceNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        approvedLenderTransitNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_1.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        exceptionToListingFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be between boolean or null',
        },
        partialPaymentReceivedFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be between boolean or null',
        },
        rentalIncomeReceivedFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be between boolean or null',
        },
        indicator: indicator_1.indicatorSchema,
        lender: lender_1.lenderSchema,
        borrowers: {
            type: ['array', 'null'],
            items: borrower_1.borrowerSchema,
        },
        property: property_1.draftPropertySchema,
        defaultManagement: default_management_1.defaultManagementSchema,
        detail: detail_1.detailSchema,
        documentAccessControlEntry: document_access_control_entry_schema_1.documentAccessControlEntrySchema,
        listings: {
            type: ['array', 'null'],
            items: listing_1.listingSchema,
        },
        borrowerCharges: {
            type: ['array', 'null'],
            items: borrower_charge_1.borrowerChargesSchema,
        },
        netOperatingIncomeRentalIncomes: {
            type: ['array', 'null'],
            items: net_operating_income_rental_income_1.netOperatingIncomeRentalIncomeSchema,
        },
        partialPayments: {
            type: ['array', 'null'],
            items: partial_payment_1.partialPaymentSchema,
        },
        attachments: {
            type: ['array', 'null'],
            minItems: 0,
            maxItems: 50,
            items: common_1.attachmentSchema,
            errorMessage: 'Should be an array of Attachments with maximum 50 attachments',
        },
    },
};
